// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608181143/js/" + chunkId + "." + {"44":"ea6bd5c2","225":"8855e5f6","481":"95908efd","486":"da7d02a8","770":"d0937850"}[chunkId] + ".0.044018395126219856.chunk.js";
};